import * as types from '../../action-types';

export default function setGiftcardMessage(message) {
  return {type: types.SET_GIFTCARD_MESSAGE, message};
}
